import { useNavigate } from "react-router-dom";
import { useAuth, ROLE_LABELS } from "@/context/AuthContext";
import { Eye, LogOut } from "lucide-react";

export function ViewAsBanner() {
  const { user, exitViewAs } = useAuth();
  const navigate = useNavigate();
  if (!user?.view_only) return null;
  return (
    <div data-testid="view-as-banner" className="sticky top-0 z-50 bg-amber-400 text-amber-950 px-4 py-2 flex flex-wrap items-center gap-3 text-sm shadow">
      <Eye size={16} />
      <span className="font-semibold">Viewing as {user.name} ({ROLE_LABELS[user.role] || user.role})</span>
      <span className="text-xs">Look only — saving and sending are blocked.</span>
      <span className="flex-1" />
      <button data-testid="view-as-exit" onClick={() => { exitViewAs(); navigate("/view-as"); }}
        className="inline-flex items-center gap-1 rounded-full bg-amber-950 text-amber-50 px-3 py-1 text-xs font-semibold hover:bg-black transition-colors">
        <LogOut size={13} /> Back to my account
      </button>
    </div>
  );
}
